import { gql, useQuery } from '@apollo/client';

import { usePostableGroups_currentUsersGroups } from './graphql-types/usePostableGroups_currentUsersGroups';

const GROUPS_QUERY = gql`
  query usePostableGroups_currentUsersGroups {
    currentUser {
      _id
      postableGroups {
        _id
        name
        isGlobalSingleton
      }
    }
  }
`;

export const usePostableGroups = (): {
  loading: boolean;
  groups: { _id: string; name: string }[] | undefined;
} => {
  const groups = useQuery<usePostableGroups_currentUsersGroups>(GROUPS_QUERY);

  return {
    loading: groups.loading,
    groups: groups.data?.currentUser?.postableGroups,
  };
};
